import {
	GENERATE_INTERVISTA_CITTADINO_FAIL,
	GENERATE_INTERVISTA_CITTADINO_START, GENERATE_INTERVISTA_CITTADINO_SUCCESS,
	GENERATE_INTERVISTA_FAIL,
	GENERATE_INTERVISTA_INCOMPLETA_FAIL,
	GENERATE_INTERVISTA_INCOMPLETA_START,
	GENERATE_INTERVISTA_INCOMPLETA_SUCCESS,
	GENERATE_INTERVISTA_START,
	GENERATE_INTERVISTA_SUCCESS, GET_INCOMPLETA_FAIL, GET_INCOMPLETA_START,
	GET_INCOMPLETA_SUCCESS,
	GET_INTERVISTA_FAIL,
	GET_INTERVISTA_START,
	GET_INTERVISTA_SUCCESS,
	SET_INTERVISTA, UPDATE_INTERVISTA_FAIL, UPDATE_INTERVISTA_START, UPDATE_INTERVISTA_SUCCESS
} from "./actions/ActionTypes";

export const initIntervistaState = () => {
	return {
		loadingAddIntervistaIncompleta: true,
		errorAddIntervistaIncompleta: "",
		loadingAddIntervista: true,
		errorAddIntervista: "",
		intervista: {},
		loadingGetIntervista: true,
		errorGetIntervista: "",
		loadingUpdateIntervista: true,
		errorUpdateIntervista: "",
		
		incompleta: {},
		loadingGetIncompleta: true,
		errorGetIncompleta: "",
		
		loadingCompilaCittadino: true,
		errorCompilaCittadino: "",
	}
}

export const INTERVISTA_INITIAL_STATE = {}

export const IntervistaReducer = (state = INTERVISTA_INITIAL_STATE, action) => {
	console.log(action, state)
	switch (action.type) {
		default:
			return state;
		case SET_INTERVISTA:
			return {
				...state,
				intervista: {...state.intervista, ...action.payload}
			}
		case GENERATE_INTERVISTA_START:
			return {
				...state,
				loadingAddIntervista: true,
				errorAddIntervista: "",
			}
		case GENERATE_INTERVISTA_SUCCESS:
			return {
				...state,
				loadingAddIntervista: false,
				errorAddIntervista: "",
				intervista: {...state.intervista, id: action.payload}
			}
		case GENERATE_INTERVISTA_FAIL:
			return {
				...state,
				loadingAddIntervista: false,
				errorAddIntervista: action.error,
			}
		case GENERATE_INTERVISTA_INCOMPLETA_START:
			return {
				...state,
				loadingAddIntervistaIncompleta: true,
				errorAddIntervistaIncompleta: "",
			}
		case GENERATE_INTERVISTA_INCOMPLETA_SUCCESS:
			return {
				...state,
				loadingAddIntervistaIncompleta: false,
				errorAddIntervistaIncompleta: "",
				intervista: {...state.intervista, id: action.payload}
			}
		case GENERATE_INTERVISTA_INCOMPLETA_FAIL:
			return {
				...state,
				loadingAddIntervistaIncompleta: false,
				errorAddIntervistaIncompleta: action.error,
			}
		case GET_INTERVISTA_START:
			return {
				...state,
				intervista: {},
				loadingGetIntervista: true,
				errorGetIntervista: "",
			}
		case GET_INTERVISTA_SUCCESS:
			return {
				...state,
				intervista: action.payload,
				loadingGetIntervista: false,
				errorGetIntervista: "",
			}
		case GET_INTERVISTA_FAIL:
			return {
				...state,
				intervista: {},
				loadingGetIntervista: false,
				errorGetIntervista: action.error,
			}
		case GET_INCOMPLETA_START:
			return {
				...state,
				incompleta: {},
				loadingGetIncompleta: true,
				errorGetIncompleta: "",
			}
		case GET_INCOMPLETA_SUCCESS:
			return {
				...state,
				incompleta: action.payload,
				loadingGetIncompleta: false,
				errorGetIncompleta: "",
			}
		case GET_INCOMPLETA_FAIL:
			return {
				...state,
				incompleta: {},
				loadingGetIncompleta: false,
				errorGetIncompleta: action.error,
			}
		case UPDATE_INTERVISTA_START:
			return {
				...state,
				loadingUpdateIntervista: true,
				errorUpdateIntervista: "",
			}
		case UPDATE_INTERVISTA_SUCCESS:
			return {
				...state,
				loadingUpdateIntervista: false,
				errorUpdateIntervista: "",
			}
		case UPDATE_INTERVISTA_FAIL:
			return {
				...state,
				loadingUpdateIntervista: false,
				errorUpdateIntervista: action.error,
			}
		case GENERATE_INTERVISTA_CITTADINO_START:
			return {
				...state,
				loadingCompilaCittadino: true,
				errorCompilaCittadino: "",
			}
		case GENERATE_INTERVISTA_CITTADINO_SUCCESS:
			return {
				...state,
				loadingCompilaCittadino: false,
				errorCompilaCittadino: "",
			}
		case GENERATE_INTERVISTA_CITTADINO_FAIL:
			return {
				...state,
				loadingCompilaCittadino: false,
				errorCompilaCittadino: action.error,
			}
	}
}
